import { render } from "./CategoryWeight.vue?vue&type=template&id=0b5828c2"
import script from "./CategoryWeight.vue?vue&type=script&lang=js"
export * from "./CategoryWeight.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__